import dpaDisclaimerHtml from "./dpa-disclaimer-content.html?raw";

export default function DpaDisclaimerPage() {
  return (
    <div className="dpa-disclaimer h-screen overflow-y-auto">
      <style>{`
        .dpa-disclaimer { scroll-behavior: smooth; background: #F4F7F9; color: #101828; }
        .dpa-disclaimer, .dpa-disclaimer *, .dpa-disclaimer *::before, .dpa-disclaimer *::after { box-sizing: content-box; }
        .dpa-disclaimer a { color: #1B6B4A; text-decoration: none; font-weight: 600; }
        .dpa-disclaimer a:hover { color: #16573C; }
        .dpa-disclaimer ::selection { background: rgba(149,188,14,0.28); }
      `}</style>
      <div dangerouslySetInnerHTML={{ __html: dpaDisclaimerHtml }} />
    </div>
  );
}
